<template>
  <div>
    <div id="overlay" v-if="fetchingData">
      <div class="spinner"></div>
    </div>
    <!--
    <base-input v-model="permitNumber" label="Permit Number">
        <button class="btn btn-primary"
              @click="searchPermitNumber"
              slot="input-append"
              :message="errorMessage"
              type="button">
        Search
      </button>
    </base-input>
  -->

    <div class="row justify-content-center">
      <div class="col-12 col-md-6">
        <base-input v-model="permitNumber"
                    label="Application Number"
                    :message="errorMessage"
                    v-focus
                    v-on:keyup.enter="searchPermitNumber">
          <!--<button class="btn btn-primary"-->
                  <!--@click="searchAppNumber"-->
                  <!--slot="input-append">-->
            <!--Search-->
          <!--</button>-->
        </base-input>
        <button class="btn btn-primary" @click="searchPermitNumber">Search</button>
      </div>
    </div>
    <div class="row mt-5" v-if="lookupPermitNumber">
      <div class="col">
        <iframe frameBorder="0" :src="sourceUrl" v-on:load="unspin" width="100%" height="1000px" type="application/pdf"/>
      </div>
      <div class="w-100"></div>
      <div class="col">
        <p>
          Trouble viewing embeded pdf's? <a :href="downloadUrl">Download here</a>.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInput from '@/components/BaseInput';
import { getPermit, checkPdf, validatePermitNumber } from '@/js/FormFunctions';


export default {
  name: 'PermitSearch',
  components: { BaseInput },
  data() {
    return {
      permitNumber: '',
      lookupPermitNumber: '',
      isValidNum: false,
      fetchingData: false,
    };
  },
  methods: {
    searchPermitNumber() {
      if (this.permitNumber == '' || this.lookupPermitNumber == this.permitNumber) {
        return;
      }
      this.fetchingData = true;
      this.isValid();
    },
    unspin(event) {
      this.fetchingData = false;
    },
    clearEmbed() {
      this.fetchingData = false;
      this.isValidNum = false;
      this.lookupPermitNumber = null;
    },
    async isValid() {
      const that = this;
      await validatePermitNumber(this.permitNumber)
        .then((data) => {
          getPermit(this.permitNumber)
            .then((data) => {
              that.canPrint();
            })
            .catch((error) => {
              that.error = error;
              that.fetchingData = false;
              that.isValidNum = false;
            });
        })
        .catch((error) => {
          this.error = error;
          this.fetchingData = false;
          this.isValidNum = false;
        });
    },
    canPrint() {
      checkPdf(this.permitNumber)
        .then((data) => {
          this.lookupPermitNumber = this.permitNumber;
        })
        .catch((error) => {
          this.error = error;
          this.fetchingData = false;
        });
    },
  },
  computed: {
    sourceUrl() {
      const doc = `${window.location.protocol}//${window.location.hostname}`
          + `${window.location.port ? `:${window.location.port}` : ''}/DesWebPortal/api/permit/permit?permitNumber=${this.lookupPermitNumber}`;
      return doc;
    },
    errorMessage() {
      if (this.error) {
        this.fetchingData = false;
        return `Error finding application:${this.permitNumber}`;
      }
      return '';
    },
    downloadUrl() {
      return `${this.sourceUrl}&download=true`;
    },
  },
};
</script>
